import { useState, type FormEvent } from 'react';
import { useI18n } from '../lib/i18n.tsx';
import { useSession } from '../lib/session.tsx';
import { ApiError } from '../lib/api.ts';
import { Button, Field } from '../components/ui.tsx';
import { Icon } from '../components/Icon.tsx';
import { BrandLogo, useBranding } from '../lib/branding.tsx';

export function LoginPage() {
  const { t, locale } = useI18n();
  const { login, setLocale } = useSession();
  const { branding, logo, organization } = useBranding();
  const tagline = locale === 'ar' ? branding.taglineAr ?? branding.tagline : branding.tagline;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true); setError(null);
    try { await login(email.trim(), password); }
    catch (err) { setError(err instanceof ApiError ? (err.code === 'locked' ? err.message : err.status === 429 ? err.message : t('auth.invalid')) : (err as Error).message); }
    finally { setBusy(false); }
  };
  return (
    <div className="login">
      <div className="art">
        <div className="brand-big"><BrandLogo height={44} plate={!!logo} /> {branding.appName}</div>
        <blockquote>“{locale === 'ar' ? 'من التصميم إلى التسليم، نحوّل الخشب إلى قيمة دائمة.' : 'From design to delivery, we turn wood into lasting value.'}”</blockquote>
        <div className="foot">{tagline ? `${tagline} · ` : ''}{t('app.copyright', { year: new Date().getFullYear(), company: organization ?? branding.appName })}{branding.poweredBy ? ` · ${t('ui.poweredBy', { product: branding.productName })}` : ''}</div>
      </div>
      <div className="pane">
        <form onSubmit={submit} noValidate>
          <div className="pane-brand"><BrandLogo height={36} /></div>
          <div><h1>{t('auth.welcome')}</h1><div className="muted">{t('auth.subtitle')}</div></div>
          {error && <div className="banner red-banner"><Icon name="TriangleAlert" /><span>{error}</span></div>}
          <Field label={t('auth.email')} required id="email"><input id="email" className="input" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus required /></Field>
          <Field label={t('auth.password')} required id="password"><input id="password" className="input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required /></Field>
          <Button variant="primary" type="submit" busy={busy} icon="LogOut" style={{ justifyContent: 'center' }}>{t('auth.signIn')}</Button>
          <div className="lang-row">
            <span>{t('auth.language')}</span>
            <span className="row" style={{ gap: 6 }}>
              <button type="button" className={`btn sm ${locale === 'en' ? 'primary' : ''}`} onClick={() => void setLocale('en')}>English</button>
              <button type="button" className={`btn sm ${locale === 'ar' ? 'primary' : ''}`} onClick={() => void setLocale('ar')}>العربية</button>
            </span>
          </div>
        </form>
      </div>
    </div>
  );
}
